import { FilterNone, FilterNoneTwoTone } from "@mui/icons-material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Typography, useTheme } from "@mui/material";
import { TreeItem, TreeItemProps } from "@mui/x-tree-view/TreeItem";
import { Property } from "csstype";
import React from "react";
import { useTranslation } from "react-i18next";
import { INavigationItem } from "../../../services/navigation-data-service/Models";
import NavigationDataService from "../../../services/navigation-data-service/NavigationDataService";

type GroupTreeItemProps = TreeItemProps & {
    showIcon?: boolean;
    navigationItem: INavigationItem,
    enableDynamicGroupRefresh?: boolean;
    includeObjectCount?: boolean;
    onLabelClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    color?: Property.Color;
};

export function GroupTreeItem(props: GroupTreeItemProps) {

    const theme = useTheme();
    const { navigationItem,
        enableDynamicGroupRefresh,
        includeObjectCount,
        showIcon,
        onLabelClick,
        color,
        ...other
    } = props;

    const { t } = useTranslation();

    const onRefreshDynamicGroup = async (event: React.MouseEvent<Element, MouseEvent>, item: INavigationItem) => {
        event.persist();
        event.stopPropagation();
        event.preventDefault();


        await NavigationDataService.refreshDynamicGroup(item.objectID);
    };


    return (
        <TreeItem
            label={
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        //padding: theme.spacing(0.5, 0),
                        color: color ?? "inherit"
                    }}
                    onClick={onLabelClick}>

                    {showIcon && navigationItem.isPeerGroup ?
                        <FilterNoneTwoTone
                            sx={{
                                marginRight: theme.spacing(1),
                                fontSize: 'small'
                            }}
                        /> :
                        <FilterNone
                            sx={{
                                marginRight: theme.spacing(1),
                                fontSize: 'small'
                            }}
                        />}

                    <Typography variant="body2"
                        sx={{
                            fontWeight: 'inherit',
                            flexGrow: 1,
                        }}
                    >
                        {includeObjectCount && navigationItem.deviceCount ? `${navigationItem.title}  [${navigationItem.deviceCount?.toString()}]` : navigationItem.title}
                        {
                            navigationItem.isDynamic && enableDynamicGroupRefresh &&
                            <Box
                                sx={{
                                    verticalAlign: 'middle',
                                    paddingLeft: theme.spacing(1)
                                }}
                                component='span'
                                aria-label={t("dynamicGroup.refresh") as string}
                                onClick={(e: React.MouseEvent<Element, MouseEvent>) => onRefreshDynamicGroup(e, navigationItem)}>
                                <RefreshIcon fontSize='small' />
                            </Box>
                        }
                    </Typography>
                </Box>
            }
            {...other}
        />
    );
}

